import React, { useEffect, useRef } from "react";
import { BadgeCheck } from "lucide-react";
import image from "../../assets/images/png/corporate-intro.png";

const CorporateIntro = () => {
  const sectionRef = useRef(null);

  useEffect(() => {
    const element = sectionRef.current;
    if (!element) {
      return undefined;
    }

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          element.classList.add("ci-visible");
          observer.disconnect();
        }
      },
      { threshold: 0.15 },
    );

    observer.observe(element);
    return () => observer.disconnect();
  }, []);

  return (
    <section className="ci-section" ref={sectionRef}>
      <div className="container">
        <div className="row align-items-center g-5">
          <div className="col-lg-5 order-1">
            <div className="ci-img-wrap">
              <div className="ci-img-inner">
                <img loading="lazy" decoding="async" src={image} alt="HKI Media Corporate" />
                <div className="ci-img-badge">
                  <BadgeCheck size={18} className="ci-img-badge-dot" />
                  <span className="intro_image_text">
                    Trusted Media Partner
                  </span>
                </div>
              </div>
            </div>
          </div>

          <div className="col-lg-7 order-2">
            <h2 className="ci-heading">
              A Professional <em>Media Partner</em>
              <br />
              Built for Businesses
            </h2>

            <div className="ci-divider" />

            <p className="ci-body">
              At HKI Media Corporate, we work with corporates, enterprises, and
              growing organizations to deliver structured, high-quality media
              and communication solutions — crafted to build authority, drive
              engagement, and leave a lasting impression.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CorporateIntro;
